import { render, staticRenderFns } from "./settings-organization-rate-card-ctrl.vue?vue&type=template&id=52a93c0e&scoped=true&"
import script from "./settings-organization-rate-card-ctrl.vue?vue&type=script&lang=js&"
export * from "./settings-organization-rate-card-ctrl.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization-rate-card-ctrl.vue?vue&type=style&index=0&id=52a93c0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a93c0e",
  null
  
)

export default component.exports